import { prodBrandCat } from 'api/globalsearh/_requests';
import axios from 'axios';
import { ProductCat } from 'data/e-commerce/products';
import { handleRequest } from 'helpers/api';

const USER_URL = `${process.env.REACT_APP_API_URL}/users`;

const userApi = axios.create({
  baseURL: USER_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface WishlistProduct {
  productId: string;
  variantId: string | null;
}

export interface AddProduct {
  userId?: string;
  productId?: string;
}

export const getWishlist = async () => {
  return handleRequest(userApi.get('/wishlist'));
};

export const getWishlistData = async () => {
  return handleRequest(userApi.get('/wishlist-data'));
};

export const addToWishlist = async (data: WishlistProduct) => {
  return handleRequest(userApi.put('/wishlist', data));
};

export const removeFromWishlist = async (data: WishlistProduct) => {
  return handleRequest(userApi.delete(`/wishlist`, { data }));
};

export const addRecentView = async (data: AddProduct) => {
  return handleRequest(userApi.post('/addrecentView', data));
};

export const getRecentViewedProducts = async (): Promise<ProductCat[]> => {
  const user = localStorage.getItem('user');

  if (user) {
    return handleRequest(userApi.get<ProductCat[]>('/recent-products'));
  }

  const localIds: string[] = JSON.parse(
    localStorage.getItem('recentProducts') || '[]'
  );
  if (!localIds.length) return [];

  return handleRequest(
    userApi.post<ProductCat[]>(`/recent-products/local`, {
      ids: localIds.slice(0, 10)
    })
  );
};
